module.exports = __webpack_public_path__ + "img/adulto16.136db1cf.jpg";